import { Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { useTranslations } from "@/translations";
import { OptimizedImage } from "@/components/ui/optimized-image";
import logoAsset from "@/assets/greatjobs-logo.png.asset.json";

const Footer = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = useTranslations(language);

  return (
    <footer className="bg-card border-t border-border py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <button 
              onClick={() => { navigate('/'); window.scrollTo(0, 0); }} 
              className="flex items-center space-x-2 mb-4 hover:opacity-80 transition-opacity"
            >
              <OptimizedImage 
                src={logoAsset.url}
                alt="GreatJobs.lk" 
                width={219}
                height={48}
                className="h-12 w-auto"
              />
            </button>
            <p className="text-muted-foreground">
              {t.footer.description}
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">{t.footer.jobSeekers}</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><button onClick={() => { navigate('/jobs'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.browseJobs}</button></li>
              <li><button onClick={() => { navigate('/job-alerts'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.nav.jobAlerts}</button></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">{t.footer.employers}</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><button onClick={() => { navigate('/post-job'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.postJobs}</button></li>
              <li><button onClick={() => { navigate('/candidate-search'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.searchCandidates}</button></li>
              <li><button onClick={() => { navigate('/ats-integration'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.atsIntegration}</button></li>
              <li><button onClick={() => { navigate('/pricing-plans'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.pricing}</button></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">{t.footer.support}</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><button onClick={() => { navigate('/contact'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.contactUs}</button></li>
              <li><button onClick={() => { navigate('/privacy-policy'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.privacyPolicy}</button></li>
              <li><button onClick={() => { navigate('/terms-of-service'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.termsOfService}</button></li>
              <li><button onClick={() => { navigate('/safety'); window.scrollTo(0, 0); }} className="hover:text-primary transition-colors">{t.footer.yourSafety}</button></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border mt-8 pt-8 flex justify-between items-center text-muted-foreground text-xs">
          <p>Made with ❤️ in Sri Lanka 🇱🇰</p>
          <p>&copy; 2026 GreatJobs.lk. {t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;